import { FC, useRef, useEffect, memo } from 'react';
import { Box, Text } from 'grommet';
import styled from 'styled-components';
import { CameraVideoOff } from '@styled-icons/bootstrap';

export const VideoBox = styled(Box)`
	span {
		display: flex;
		flex-direction: column;
		svg {
			margin-bottom: 4px;
		}
	}
	video {
		height: 100%;
		width: 100%;
		object-fit: cover;
	}
`;

type VideoContainerProps = {
	videoElement?: HTMLVideoElement;
	videoStatus?: boolean;
	isLoading?: boolean;
};

const VideoHolder: FC<VideoContainerProps> = ({
	videoElement,
	videoStatus,
	isLoading = false,
}: VideoContainerProps) => {
	const videoContainerRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (!videoContainerRef.current || !videoElement || isLoading) {
			return;
		}

		let shouldAbortExecution = false;

		setTimeout(() => {
			if (shouldAbortExecution || !videoContainerRef.current) return;
			videoContainerRef.current.appendChild(videoElement);
		}, 400);

		// eslint-disable-next-line consistent-return
		return () => {
			shouldAbortExecution = true;
			videoElement.remove();
		};
	}, [videoElement, isLoading]);

	return (
		<VideoBox
			width="full"
			height="90px"
			style={{ objectFit: 'cover' }}
			background="white"
			ref={videoContainerRef}
		>
			{!videoStatus && (
				<Box
					width="100%"
					height="100%"
					background="white"
					align="center"
					justify="center"
					style={{ position: 'absolute' }}
				>
					<Text color="brand" weight="bold">
						<CameraVideoOff size="30px" />
						You
					</Text>
				</Box>
			)}
		</VideoBox>
	);
};

export default memo(VideoHolder);
